
<app-header-helena bannerImage="gentlemanHoldingSeedsBanner.webp"></app-header-helena>

<h4 >New! Enhanced Services for Seed Coating</h4>
<p>Yara products applied as seed coatings have proved to be a important way of enhancing the 
  value of seed products. Due to the surge of interest, we have added the seed treatment product development process to this website. 
It is now quick and easy to get a potential seed coating developed and tested.  <a [routerLink]="['/request-seed-treatment']" >Find out more </a>  </p>

<div *ngIf="!results">
  <h2  >Search</h2>
  <form *ngIf="!searching" [formGroup]="searchForm">
    <div class="sideBySide">
      <div >
       
        <div class="form-group">
          <label
          for="yaraChemicalId"
          
          >Choose a Yara Product (optional)
        </label>
        <app-nameid-typeahead
          [items]="yaraProductChoices"
          id="yaraChemicalId"
          formControlName="yaraChemicalId"
        ></app-nameid-typeahead>
        <small class="form-text textmuted"> </small>
        </div>
      </div>

      <div  >
        <div class="form-group">
          <label for="cropDropDown">Choose a Crop </label>
          <select id="cropDropDown" name="cropDropDown"  formControlName="seedName">
            <option *ngFor="let choice of cropChoices" [value]="choice.id">{{ choice.name }}</option>
          </select>
          <small class="form-text textmuted"> </small>
        </div>
      
      </div>
    </div>
    <br/>
    <div>
      <button class="btn-success" (click)="performSearch()">Search for Seed Treatments</button>
      <button class="btn" (click)="resetSearch()">Reset</button>
    </div>
  </form>
  <div *ngIf="searching">
    Searching ......
  </div>
</div>
<div *ngIf="results">
  <h3>Search Results</h3>
  <div *ngIf="!results.length" class="alert alert-info">
    <p>No Tankmix results were found.</p>
    <p>You may adjust your criteria, or you can ask one of our chemist to carry out a new test for you.</p>

    <a routerLink="/request"> <button class="btn">Request Chemical Analysis</button></a>
  </div>

  <div *ngIf="results.length">
    <app-units-chooser></app-units-chooser>
    <table class="table-yara">
      <thead>
        <tr>
          <th>Date Tested</th>
          <th>Result</th>
       
          <th>Download Report</th>
          <th>Products</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let test of results">
          <td>{{ test.dateOfTest | date }}</td>
          <td>
            <fa-icon [icon]="test.result | tankmixResultTransform" size="2x"></fa-icon>
          </td>
     
          <td>
            <a href="testResult/{{test.tankmixId}}">
              <fa-icon [icon]="faFilePdf" size="2x"></fa-icon>
            </a>
          </td>
          <td>
            <table class="ingredientTable">
              <thead>
                <tr>
                  <th class='numberColumn'>Order</th>
                  <th class='numberColumn'>Rate</th>
                  <th>Name</th>
                  <th class='manufacturerColumn'>Manufacturer</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ingredient of test.ingredients">
                  <td>{{ ingredient.orderOfAddition }}</td>
                  <td>{{ convertedAppRate(ingredient.rate) | number:'1.2-2' }}</td>
                 
                  <td>
                    <span *ngIf="!ingredient.products">{{ ingredient.name }}</span>
                    <div *ngIf="ingredient.products">
                      <span *ngFor="let product of ingredient.products">{{ product }}, </span>
                    </div>
                  </td>
                  <td>{{ ingredient.manufacturer }}</td>

                </tr>
              </tbody>
            </table>
            <span *ngIf="test.observations">{{ test.obserations }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <button class="btn" (click)="searchAgain()">Adjust Search Criteria</button>
</div>

